import { styled } from '@mui/material/styles';
import { Box, Button, TableCell, TableRow, Typography, Checkbox } from '@mui/material';

export const StyledTableRow = styled(TableRow)(({  }) => ({
  height: '48px',
  '&:hover': { 
    backgroundColor: '#f0f0f0' 
  },
  '& th': {
    fontWeight: 'bold',
    backgroundColor: 'white',
  }
}));

export const HeaderCell = styled(TableCell)(({  }) => ({
  fontWeight: 'bold',
  '&:last-child': {
    borderRight: 'none'
  }
}));

export const SelectAllText = styled(Box)(({  }) => ({
  color: '#00BCD4',
  fontSize: '0.75rem',
  cursor: 'pointer',
  marginTop: '4px',
  textAlign: 'right',
  whiteSpace: 'nowrap',
  '&:hover': {
    textDecoration: 'underline'
  }
}));

export const StyledCheckbox = styled(Checkbox)({
  color: '#00BCD4',
  '&.Mui-checked': {
    color: '#00BCD4',
  },
  '& .MuiSvgIcon-root': {
    fontSize: '1.25rem',
  },
  padding: '4px'
});

export const StyledTableCell = styled(TableCell)<{ columnIndex?: number }>(({  columnIndex }) => ({

  padding: '4px 8px',
  fontSize: '14px',
  borderBottom: 'none',
  backgroundColor: columnIndex === 1 ? '#E7EFF5' : 'white',
  '&:last-child': {
    borderRight: 'none'
  }
}));

export const SaveButton = styled(Button)(({  }) => ({
  textTransform: 'uppercase',
  fontWeight: 'bold',
  backgroundColor: '#f0f7fa',
  borderRadius: '24px',
  color: '#000',
  '&:hover': {
    backgroundColor: '#e0eef5',
  }
}));

export const SectionTitle = styled(Typography)(({ theme }) => ({
  marginTop: theme.spacing(4),
  marginBottom: theme.spacing(2),
  fontWeight: 'bold'
}));

export const FootnoteContainer = styled(Box)(({ theme }) => ({
  marginTop: theme.spacing(4),
  color: '#666',
  fontSize: '0.875rem'
}));

export const FootnoteText = styled(Typography)(({  }) => ({
  color: 'textSecondary',
  fontSize: '0.875rem',
  lineHeight: 1.5
})); 